import {Grid, Typography} from '@yandex-delivery/blocks'

import {
  CommentInput,
  DoorCodeInput,
  EntranceInput,
  FlatInput,
  FloorInput,
  PhoneInput,
} from 'src/shared/components/desktop'
import {appConfig, i18n} from 'src/shared/config'

import {AddressSuggest} from '../../AddressSuggest/AddressSuggest'
import * as classes from './ReturnPointModal.classes'

export function ReturnPointForm() {
  return (
    <Grid direction="column" size="m" container>
      <Grid item xs>
        <AddressSuggest
          commentName={'returnPoint.address._comment'}
          location={appConfig.location}
          name={'returnPoint.address'}
          pointType="a"
        />
      </Grid>
      <Grid xs={12} container item>
        <Grid justify="flex-start" xs={12} item>
          <Typography thickness="medium" variant="body2">
            {i18n('cargo.create.address.address', 'Адрес')}
          </Typography>
        </Grid>
        <Grid xs={12} container item>
          <Grid md={3} xs={6} item>
            <EntranceInput
              name="returnPoint.address.porch"
              names={{
                locationName: 'returnPoint.address.coordinates',
                logName: 'returnPoint.address.log',
                shortName: 'returnPoint.address.shortName',
                fullName: 'returnPoint.address.fullName',
              }}
            />
          </Grid>
          <Grid md={3} xs={6} item>
            <DoorCodeInput name="returnPoint.address.doorCode" />
          </Grid>
          <Grid md={3} xs={6} item>
            <FloorInput name="returnPoint.address.floor" />
          </Grid>
          <Grid md={3} xs={6} item>
            <FlatInput name="returnPoint.address.flat" />
          </Grid>
          <Grid xs={12} item>
            <CommentInput name="returnPoint.address.comment" />
          </Grid>
        </Grid>
      </Grid>
      <Grid direction="column" size="s" xs={12} container item>
        <Grid justify="flex-start" xs={12} item>
          <Typography thickness="medium" variant="body2">
            {i18n('cargo.create.contact.phone', 'Телефон')}
          </Typography>
        </Grid>
        <Grid justify="flex-start" xs={12} item>
          <PhoneInput className={classes.phoneInput} name="returnPoint.contact.phone" />
        </Grid>
      </Grid>
    </Grid>
  )
}
